<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 入退場状況：閲覧の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>入退場状況：閲覧の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-transit-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> イベント
        </div>
        <div class="manual-explain">
          イベントが表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 来場日
        </div>
        <div class="manual-explain">
          入退場状況を表示する来場日を選択します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 入場口
        </div>
        <div class="manual-explain">
          入場口ごとの通過回数と最後に通過した日時が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 退場口
        </div>
        <div class="manual-explain">
          退場口ごとの通過回数と最後に通過した日時が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> エントリー番号
        </div>
        <div class="manual-explain">
          エントリー番号が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 展示
        </div>
        <div class="manual-explain">
          展示ごとの来場回数と最後に来場した日時が表示されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Entry/Exit Status: View
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Entry/Exit Status: View</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-transit-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Event
        </div>
        <div class="manual-explain">
          The event is displayed.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Visit Date
        </div>
        <div class="manual-explain">
          Select the visit date to display entry/exit status.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Entrance
        </div>
        <div class="manual-explain">
          The number of passes through each entrance and the last pass time are displayed.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Exit
        </div>
        <div class="manual-explain">
          The number of passes through each exit and the last pass time are displayed.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Entry Number
        </div>
        <div class="manual-explain">
          The entry number is displayed.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Exhibit
        </div>
        <div class="manual-explain">
          The number of visits to each exhibit and the last visit time are displayed.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
